import { mapGetters } from 'vuex';
export default {
    name: 'marketTrendsTabHeader',
    props: {
      tabHeader: {
        type: Object,
        default: null
      },
      city:{
        type: Object,
        default: null
      },
      isWidget: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('glb', ['glb'])
    },
    mounted () {
    }
  };
